import { useState, useEffect } from "react";

const useCameraStatus = () => {
  const [cameraAllowed, setCameraAllowed] = useState(false);

  useEffect(() => {
    const checkCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        setCameraAllowed(true);
        stream.getTracks().forEach(track => track.stop());
      } catch {
        setCameraAllowed(false);
      }
    };

    checkCamera();
  }, []);

  return cameraAllowed;
};

export default useCameraStatus;